import { PageMetas } from '@interfaces/config';
import { KcContentFilter } from '@interfaces/knowledge-center';
import { FieldLocationEnum, NewsMediaEnum } from '@models/enums';

import { IPhoneNumber } from '@interfaces/index';
import { SocialLinks } from '@interfaces/config/cms-components/social-links-config';
import { IResponsiveImageConfig } from '@components/common/_media/image/image.component';

export const LOCALSTORAGE_GATED_KEY = 'GATED_ALLOWED';
export const LOCALSTORAGE_ELOQUA_USER_KEY = 'ELOQUA_USER';
export const LOCALSTORAGE_SPS_USER_KEY = 'SPS_USER';
export const CURRENT_ENABLED_URL = "CURRENT_ENABLED_URL";
export const LOCALSTORAGE_SPS_WEBINAR_KEY = "SPS_WEBINAR";
export const LOCALSTORAGE_SPS_TRENDCOMMERCE_KEY = "SPS_TRENDCOMMERCE";
export const LOCALSTORAGE_SOCIAL_WIDGET_KEY = 'SOCIAL_WIDGET';
export const LOCALSTORAGE_WEBINAR_WIDGET_KEY = 'WEBINAR_WIDGET';
export const LOCALSTORAGE_SOCIAL_WIDGET_EXPIRY = 30 * 24 * 60 * 60 * 1000; // 30 days

export const VIRTUAL_FILES_SUB_PATH = '/internal/files';

export const GATED_FORM_IDS = { EN: 763, DE: 707 };
export const GATED_TRACKING_FORM_ID: number = 722;
export const GATED_EVENT_FORM_ID: number = 786;

export const CONTACT_FORM_IDS = { EN: 703 };
export const NEWSLETTER_FORM_IDS = { EN: 721 };
export const US_FORM_IDS = [710, 711];

export const DEFAULT_HTTP_TIMEOUT = 7000;

export const USER_SESSION_EXPIRY_TIME = 24 * 60 * 60 * 1000; // 1 day;

export const PHONE_NUMBERS: Record<string, IPhoneNumber> = {
  DE: { raw: '+41442089500', formatted: '+41 44 208 9500' },
  US: { raw: '+187772753677', formatted: '+1 877 275 3677' },
};

export const MIN_NAV_ITEM_WEIGHT = -9999;

export const ALLOWED_HTML_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'strong', 'b', 'em', 'i', 'p', 'ul', 'ol', 'li'];

export const SLIDERS_CONFIG = {
  DEFAULT_SLIDE_SPEED: 5000,
};

export const GRID_BREAKPOINTS = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1360,
  XXL: 1400,
};

export const TOAST_TIMEOUT = 5000;

// TODO: SPS needs to provide defaults
export const DEFAULT_CMS_PAGE_METAS: PageMetas = {
  title: 'SPS Global - THE POWER OF POSSIBILITY',
  description:
    'Welcome to SPS a global full-service provider in document management. Change your digital transformation journey with us.',
  keywords: '',
  image: 'https://www.spsglobal.com/assets/images/img-sps-logo.svg',
  robots: 'index, follow',
};

export const DEFAULT_SOCIAL_LINKS_CONFIG: SocialLinks.ComponentConfig = {
  message: false,
  sharing: false,
  YOUTUBE: true,
  LINKEDIN: true,
  X: false,
  SPOTIFY: true,
  email: false,
  newsletter: false,
};

export namespace KC {
  export const FILTER_DEBOUNCE_TIME = 200;
  export const PAGE_SIZE = 12;
  export const DEFAULT_FILTERS: KcContentFilter = {
    documentType: 'ALL',
    needle: '',
    industry: 'ALL',
    topic: 'ALL', // KC PHASE 2
    solution: 'ALL', // KC PHASE 1
    pageSize: PAGE_SIZE,
    offset: 0,
    currentPage: 0,
    location: FieldLocationEnum.ALL,
    mediaType: NewsMediaEnum.ALL,
    category: ['ALL'],
  };
}

export const SPS_USER_CREDENTIALS = {
  username: 'sps.salesteam',
  password: 'AIchatbot2023#',
};

export const DEFAULT_RESPONSIVE_IMAGE_CONFIG: IResponsiveImageConfig = {
  src: null,
  srcSet: null,
  sizes: null,
  metas: { width: null, height: null, alt: 'Image ' },
  placeholder: false,
  priority: false,
  loading: 'auto',
  fill: false,
};

export const SPS_GRID_BREAKPOINTS = {
  XS: '0',
  SM: '576px',
  MD: '768px',
  LG: '992px',
  XL: '1360px',
  XXL: '1400px',
} as const;
